/* Nebula bundle builder: pick a pack size, fill it with flavors, add one bundle line with a Products property */
(function () {
  function money(cents, trim) {
    var fmt = (window.shopSettings && window.shopSettings.moneyFormat) || '${{amount}}';
    var n = cents / 100;
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (key === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
    return trim ? out.replace(/\.00$/, '') : out;
  }

  function init(root) {
    if (!root || root.dataset.nbReady) return;
    root.dataset.nbReady = '1';
    var data = JSON.parse(root.querySelector('[data-nb-bundle-data]').textContent);
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });

    var sizes = Array.prototype.slice.call(root.querySelectorAll('.nb-bundle__size input'));
    var flavors = Array.prototype.slice.call(root.querySelectorAll('[data-flavor]'));
    var form = root.querySelector('.nb-bundle__form');
    var idInput = root.querySelector('[data-nb-id]');
    var prop = root.querySelector('[data-nb-prop]');
    var planInput = root.querySelector('[data-nb-plan-input]');
    var purchase = root.querySelectorAll('[data-nb-purchase]');
    var freqWrap = root.querySelector('[data-nb-freq]');
    var freqSel = root.querySelector('[data-nb-freq-select]');
    var atc = root.querySelector('[data-nb-atc]');
    var msg = root.querySelector('[data-nb-msg]');
    var hint = root.querySelector('[data-nb-hint]');
    var ship = root.querySelector('[data-nb-ship]');
    var bar = root.querySelector('[data-nb-bar]');
    var barBtn = root.querySelector('[data-nb-bar-btn]');
    var freeShip = parseInt(root.dataset.freeShip || '0', 10);
    var counts = flavors.map(function () { return 0; });
    var order = []; // flavor indexes in the order they were added

    function limit() {
      var s = sizes.filter(function (i) { return i.checked; })[0];
      return s ? parseInt(s.dataset.count, 10) : 0;
    }
    function variant() {
      var s = sizes.filter(function (i) { return i.checked; })[0];
      return s ? byId[s.value] : data.variants[0];
    }
    function total() { return counts.reduce(function (a, b) { return a + b; }, 0); }
    function isSub() {
      var p = root.querySelector('[data-nb-purchase]:checked');
      return p && p.value === 'sub';
    }
    function plan(v) {
      if (!v.plans.length) return null;
      var id = freqSel && freqSel.value ? parseInt(freqSel.value, 10) : v.plans[0].id;
      return v.plans.filter(function (p) { return p.id === id; })[0] || v.plans[0];
    }
    function nextSize() {
      var cur = limit();
      var bigger = sizes.filter(function (i) { return !i.disabled && parseInt(i.dataset.count, 10) > cur; });
      bigger.sort(function (a, b) { return a.dataset.count - b.dataset.count; });
      return bigger[0] || null;
    }

    function add(i) {
      if (total() >= limit()) { render('full'); return; }
      counts[i]++; order.push(i); render();
    }
    function remove(i) {
      if (counts[i] <= 0) return;
      counts[i]--;
      var k = order.lastIndexOf(i);
      if (k > -1) order.splice(k, 1);
      render();
    }
    function trimToLimit() {
      while (total() > limit() && order.length) {
        var i = order.pop();
        counts[i]--;
      }
    }
    function fillEvenly() {
      var avail = flavors.map(function (f, i) { return f.dataset.available === 'true' ? i : -1; }).filter(function (i) { return i > -1; });
      if (!avail.length) return;
      counts = counts.map(function () { return 0; });
      order = [];
      for (var n = 0; n < limit(); n++) {
        var i = avail[n % avail.length];
        counts[i]++; order.push(i);
      }
      render();
    }

    function buildFreq(v) {
      if (!freqSel) return;
      var keep = freqSel.value;
      freqSel.innerHTML = '';
      v.plans.forEach(function (p) {
        var o = document.createElement('option');
        o.value = p.id;
        o.textContent = p.label + (p.pct ? ' (save ' + p.pct + '%)' : '');
        freqSel.appendChild(o);
      });
      if (keep && v.plans.some(function (p) { return String(p.id) === keep; })) freqSel.value = keep;
    }

    function render(reason) {
      var v = variant();
      var lim = limit();
      var n = total();
      var left = lim - n;
      idInput.value = v.id;

      // flavor cards
      flavors.forEach(function (f, i) {
        var c = f.querySelector('[data-nb-count]');
        if (c) c.textContent = counts[i];
        f.classList.toggle('is-picked', counts[i] > 0);
        var minus = f.querySelector('[data-nb-minus]');
        if (minus) minus.disabled = counts[i] === 0;
      });

      // summary
      root.querySelector('[data-nb-size-label]').textContent = v.title;
      root.querySelector('[data-nb-progress-txt]').textContent = n + ' of ' + lim + ' picked';
      var slots = root.querySelector('[data-nb-slots]');
      slots.innerHTML = '';
      slots.style.setProperty('--n', Math.max(lim, 1));
      var filled = [];
      counts.forEach(function (c, i) { for (var k = 0; k < c; k++) filled.push(flavors[i].style.getPropertyValue('--c')); });
      for (var s = 0; s < lim; s++) {
        var el = document.createElement('span');
        if (filled[s]) { el.className = 'is-filled'; el.style.setProperty('--c', filled[s]); }
        slots.appendChild(el);
      }
      var list = root.querySelector('[data-nb-list]');
      list.innerHTML = '';
      counts.forEach(function (c, i) {
        if (!c) return;
        var li = document.createElement('li');
        li.style.setProperty('--c', flavors[i].style.getPropertyValue('--c'));
        li.innerHTML = '<span><i></i></span><span>×' + c + '</span>';
        li.firstChild.appendChild(document.createTextNode(flavors[i].dataset.short));
        list.appendChild(li);
      });

      // hint + upsell
      hint.innerHTML = '';
      var up = nextSize();
      if (left > 0) {
        hint.textContent = reason === 'full' ? '' : 'Pick ' + left + ' more to complete your pack.';
      } else if (up) {
        var uv = byId[up.value];
        var extra = parseInt(up.dataset.count, 10) - lim;
        var saveTxt = uv.compare > uv.price ? ' and save ' + money(uv.compare - uv.price, true) : '';
        hint.appendChild(document.createTextNode((reason === 'full' ? 'Your pack is full. ' : 'Pack complete! ') + 'Want ' + extra + ' more? '));
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = 'Make it a ' + uv.title + saveTxt;
        b.addEventListener('click', function () { up.checked = true; render(); });
        hint.appendChild(b);
      } else if (reason === 'full') {
        hint.textContent = 'Your pack is full. Remove one to swap flavors.';
      } else {
        hint.textContent = 'Pack complete!';
      }

      // pricing
      var hasPlans = v.plans.length > 0;
      buildFreq(v);
      var sub = hasPlans && isSub();
      var p = plan(v);
      var price = sub && p ? p.price : v.price;
      var once = root.querySelector('[data-nb-once]');
      if (once) once.textContent = money(v.price);
      var subEl = root.querySelector('[data-nb-sub]');
      if (subEl && p) subEl.textContent = money(p.price);
      var pct = root.querySelector('[data-nb-pct]');
      if (pct && p) pct.textContent = p.pct ? 'SAVE ' + p.pct + '%' : '';
      if (planInput) { planInput.disabled = !sub; planInput.value = sub && p ? p.id : ''; }
      if (freqWrap) freqWrap.hidden = !sub || v.plans.length < 2;
      root.querySelector('[data-nb-total]').textContent = money(price);
      var cmp = root.querySelector('[data-nb-compare]');
      cmp.textContent = v.compare > price ? money(v.compare) : '';

      if (ship && freeShip > 0) {
        ship.textContent = price >= freeShip ? 'You unlocked free shipping!' : money(freeShip - price) + ' away from free shipping';
      }

      // property + buttons
      prop.value = counts.map(function (c, i) {
        return c ? flavors[i].dataset.title + ' (x' + c + ')' : null;
      }).filter(Boolean).join(', ');
      var ready = n === lim && lim > 0 && v.available;
      atc.disabled = !ready;
      atc.textContent = ready ? 'ADD TO CART · ' + money(price) : (left > 0 ? 'PICK ' + left + ' MORE' : 'SOLD OUT');
      flavors.forEach(function (f) {
        var plus = f.querySelector('[data-nb-plus]');
        if (plus) plus.setAttribute('aria-disabled', n >= lim ? 'true' : 'false');
      });

      if (bar) {
        root.querySelector('[data-nb-bar-count]').textContent = n + '/' + lim + ' picked · ' + money(price);
        root.querySelector('[data-nb-bar-fill]').style.width = (lim ? Math.round(n / lim * 100) : 0) + '%';
        barBtn.disabled = !v.available;
        barBtn.textContent = ready ? 'ADD TO CART' : 'PICK ' + left + ' MORE';
      }
    }

    sizes.forEach(function (s) { s.addEventListener('change', function () { trimToLimit(); render(); }); });
    flavors.forEach(function (f, i) {
      var plus = f.querySelector('[data-nb-plus]');
      var minus = f.querySelector('[data-nb-minus]');
      if (plus) plus.addEventListener('click', function () { add(i); });
      if (minus) minus.addEventListener('click', function () { remove(i); });
    });
    var even = root.querySelector('[data-nb-even]');
    if (even) even.addEventListener('click', fillEvenly);
    purchase.forEach(function (r) { r.addEventListener('change', function () { render(); }); });
    if (freqSel) freqSel.addEventListener('change', function () { render(); });

    form.addEventListener('submit', function (e) {
      var v = variant();
      if (total() !== limit() || !v.available) { e.preventDefault(); render(); return; }
      var drawer = document.querySelector('mini-cart');
      if (!window.fetch || !drawer || !(window.shopSettings && window.shopSettings.cartDrawer)) return;
      e.preventDefault();
      var item = { id: v.id, quantity: 1, properties: {} };
      item.properties[root.dataset.property || 'Products'] = prop.value;
      if (planInput && !planInput.disabled && planInput.value) item.selling_plan = parseInt(planInput.value, 10);
      atc.classList.add('is-loading');
      if (msg) msg.hidden = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item], sections: drawer.getSectionsToRender().map(function (s) { return s.section; }), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          drawer.renderContents(res.body);
        })
        .catch(function (err) { if (msg) { msg.textContent = err.message; msg.hidden = false; } })
        .finally(function () { atc.classList.remove('is-loading'); });
    });

    if (bar) {
      barBtn.addEventListener('click', function () {
        if (total() === limit()) {
          if (form.requestSubmit) form.requestSubmit(); else atc.click();
        } else {
          var target = root.querySelector('.nb-bundle__flavors');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { bar.classList.toggle('is-hidden', en.isIntersecting); });
        }).observe(atc);
      }
    }

    render();
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-nb-bundle]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
